import { useLocation } from "react-router-dom";

import styled from "styled-components";
import { invertedGoldenRatio } from "theme/constants";

import { useOtherNetworks } from "CrossFeatureComponents/MemberToolbar/API/queryHooks";
import FnrTypography from "FnrTypography";

import FnrNetworkPhoto from "UI/FnrNetworkPhoto";
import FnrScaleIt from "UI/FnrScaleIt";
import FnrScrollNFade from "UI/FnrScrollNFade";

import { useCopyTextColor } from "../stateHooks";

const OtherNetworks = () => {
  const otherNetworks = useOtherNetworks();
  const color = useCopyTextColor();
  const location = useLocation();
  const isGivePage = location.pathname === "/give";

  return (
    <OtherNetworksContainer>
      <FnrTypography type="copy" bold fontSize="xs" color={color} capitalize>
        OTHER NETWORKS:
      </FnrTypography>
      <FnrScrollNFade
        fadeThickness={40}
        maxHeight={`${(Math.pow(invertedGoldenRatio, 3) * 100).toFixed()}vh`}
      >
        <NetworksGapMaker>
          {otherNetworks.map(({ domain, name, photoURL }) => {
            const link = `https://${domain}${isGivePage ? "/give" : ""}`;

            return (
              <NetworkWrapper
                key={domain}
                onClick={() => (window.location.href = link)}
              >
                <FnrScaleIt scale={0.9}>
                  <FnrNetworkPhoto size="xs" shape="circle" src={photoURL} />
                </FnrScaleIt>
                <FnrTypography
                  color={color}
                  type="copy"
                  fontSize="sm"
                  key={domain}
                >
                  {name}
                </FnrTypography>
              </NetworkWrapper>
            );
          })}
        </NetworksGapMaker>
      </FnrScrollNFade>
    </OtherNetworksContainer>
  );
};

const NetworksGapMaker = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NetworkWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`;

const OtherNetworksContainer = styled.div`
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export { OtherNetworks };
